module.exports = __webpack_public_path__ + "media/images/emblems/Breggia_CoA-b084d17b87b76521ec6b0677690e1791.png";